import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { Invoice } from "@common/types/invoice";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { DocumentMatchCellContent } from "@components/accounting/transactionMatch/DocumentMatchCellContent";
import { InvoicesViewCallbacks, InvoicesViewOptions } from "../types";

export const InvoiceMatchCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Invoice, unknown>) => {
        const invoiceId = row.original.id;
        const { options } = useViewTableMeta<
            InvoicesViewCallbacks,
            InvoicesViewOptions
        >(table);

        return (
            <DocumentMatchCellContent
                documentType="invoice"
                documentId={invoiceId}
                status={options?.accrualMatchSummariesStatus}
                summary={options?.accrualMatchSummaries?.get(invoiceId)}
                readonly={options?.readonly}
            />
        );
    },
);
InvoiceMatchCell.displayName = "InvoiceMatchCell";
